<template>
  <hr class="footer-line" />
  <div :class="['footer-section', languageClass]">
    <div class="footer-left-section">
      <div class="footer-img-container">
        <img src="../assets/img/nuro9_logo.png" />
      </div>
      <div class="footer-copyright">
        Copyright 2024. Nuro9 Co., Ltd. All rights reserved.
      </div>
      <!-- 법적 링크 -->
      <div class="footer-legal-links">
        <router-link :to="termsLink" class="footer-legal-link">
          {{ isEnglish ? "Terms of Service" : "서비스 이용약관" }}
        </router-link>

        <span class="footer-legal-divider">|</span>

        <router-link :to="locationTermsLink" class="footer-legal-link">
          {{
            isEnglish
              ? "Location-Based Service Terms"
              : "위치기반 서비스 이용약관"
          }}
        </router-link>

        <span class="footer-legal-divider">|</span>

        <router-link
          :to="privacyLink"
          class="footer-legal-link footer-legal-link--bold"
        >
          {{ isEnglish ? "Privacy Policy" : "개인정보 처리방침" }}
        </router-link>
      </div>
    </div>
    <div class="footer-right-section">
      <div class="footer-info1">
        <div class="footer-info1-title">INFORMATION</div>
        <div>
          <div class="footer-info1-subtitle">{{ $t("companyNameTitle") }}</div>
          <div class="footer-info1-text1">{{ $t("companyname") }}</div>
        </div>
      </div>
      <div class="footer-info2">
        <div class="footer-info2-title">ADDRESS</div>
        <div class="footer-info2-text">
          {{ $t("address1") }} <br />
          {{ $t("address2") }}
        </div>
      </div>
      <div class="footer-info3">
        <div class="footer-info3-title">CONTACT</div>
        <div>
          <div class="footer-info3-subtitle">{{ $t("tel") }}</div>
          <div class="footer-info3-text1">+82-70-7720-9874</div>
        </div>
        <div>
          <div class="footer-info3-subtitle">{{ $t("fax") }}</div>
          <div class="footer-info3-text1">+82-31-5171-5128</div>
        </div>
        <div>
          <div class="footer-info3-subtitle">{{ $t("email") }}</div>
          <div class="footer-info3-text">ceo@gfyhealth.com</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    languageClass() {
      return `lang-${this.$i18n.locale}`;
    },

    isEnglish() {
      return this.$i18n.locale === "en";
    },

    termsLink() {
      return this.isEnglish ? "/en/terms-of-service" : "/terms-of-service";
    },

    locationTermsLink() {
      return this.isEnglish ? "/en/location-terms" : "/location-terms";
    },

    privacyLink() {
      return this.isEnglish ? "/en/privacy-policy" : "/privacy-policy";
    },
  },
};
</script>

<style>
@import "../assets/css/footer.css";
</style>
